const BASE = 10;
export const space = (size = 1) => `${size * BASE}px`;
